import { Toast } from "@tento-ui/components/toast/toast";
import { Storybook } from "@tento-ui/ui/storybook";
import { RsvpStatusList } from "@tento-lona/sheets-ui";
import { DomUtils } from "@tento-ui/dom";

export class RsvpStatusListStoryBook extends Storybook.Default {
  title(): string {
    return "RSVP Status List";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "RSVP Status List",
        render: () => {
          return RsvpStatusList.makeWith((status) => {
            Toast.info(`Selected status: ${status}`);
          }).assignStyles({
            width: "240px",
            border: "1px solid var(--divider)",
          });
        },
      },
    ];
  }
}
